import { useNavigation } from '@/navigation/NavigationContex';
import { AccordionItem } from '../../components/AccordionItem';
import { AccordionItemContent } from '../../components/AccordionItemContent';
import { AccordionItemHeader } from '../../components/AccordionItemHeader';
import { translate } from '@/translation/translate.ts';
import { RenderField } from '@/form/fields/RenderField';

const AncestryWhite = () => {
  const { currentSlide } = useNavigation();

  const ancestryNorthernEuropean = currentSlide!.fields.find(({ name }) => name === 'ancestryNorthernEuropean');
  const ancestryMiddleEastern = currentSlide!.fields.find(({ name }) => name === 'ancestryMiddleEastern');
  const ancestryEasternEuropean = currentSlide!.fields.find(({ name }) => name === 'ancestryEasternEuropean');
  const ancestryNorthAmerican = currentSlide!.fields.find(({ name }) => name === 'ancestryNorthAmerican');
  const ancestryWesternEuropean = currentSlide!.fields.find(({ name }) => name === 'ancestryWesternEuropean');
  const ancestryWhiteSouth = currentSlide!.fields.find(({ name }) => name === 'ancestryWhiteSouth');
  const ancestryNorthCoast = currentSlide!.fields.find(({ name }) => name === 'ancestryNorthCoast');
  const ancestryWhiteCaribbean = currentSlide!.fields.find(({ name }) => name === 'ancestryWhiteCaribbean');
  const ancestryMediterranean = currentSlide!.fields.find(({ name }) => name === 'ancestryMediterranean');
  const ancestryOtherWhite = currentSlide!.fields.find(({ name }) => name === 'ancestryOtherWhite');

  return (
    <AccordionItem>
      <AccordionItemHeader>{translate(currentSlide?.titles?.white)}</AccordionItemHeader>
      <AccordionItemContent>
        <RenderField slideId={currentSlide!.id} field={ancestryNorthernEuropean!} />
        <RenderField slideId={currentSlide!.id} field={ancestryMiddleEastern!} />
        <RenderField slideId={currentSlide!.id} field={ancestryEasternEuropean!} />
        <RenderField slideId={currentSlide!.id} field={ancestryNorthAmerican!} />
        <RenderField slideId={currentSlide!.id} field={ancestryWesternEuropean!} />
        <RenderField slideId={currentSlide!.id} field={ancestryWhiteSouth!} />
        <RenderField slideId={currentSlide!.id} field={ancestryNorthCoast!} />
        <RenderField slideId={currentSlide!.id} field={ancestryWhiteCaribbean!} />
        <RenderField slideId={currentSlide!.id} field={ancestryMediterranean!} />
        <RenderField slideId={currentSlide!.id} field={ancestryOtherWhite!} />
      </AccordionItemContent>
    </AccordionItem>
  );
};

export default AncestryWhite;
